import { isAtMostNChar } from "@finway-group/shared/lib/utils/common"
import { MAX_COST_CENTER_ID_LENGTH, textMultipleWhiteSpace, textNoWhiteSpacesRegex } from "@finway-group/shared/lib/utils/validators"
import { FormInstance, Rule } from "antd/lib/form"
import { stringRules } from "~Components/forms/rules/common/string.rules"
import i18n from "~Shared/locales/i18n"
import { FormService } from "~Shared/services"
import { isNotSet, isUniqueInReduxAndForm } from "~Shared/utils/helper.utils"

export const createCostCenter2Rules = (formInstance: FormInstance, isEdit: boolean, formIsArray?: boolean) => ({
    code: [
        {
            validator: (_rule, value: string) => {
                if (!value) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                const { formValues, existingValuesRaw } = FormService.getFormAndReduxValues("costCenters2", formInstance, formIsArray)
                if (!isUniqueInReduxAndForm({ formValues, existingValuesRaw, valueKey: "code", value, isEdit })) {
                    return Promise.reject(i18n.t("validation:unique", { value: i18n.t("validation:account_code") }))
                }

                if (!textNoWhiteSpacesRegex.test(value)) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space")))
                }

                if (!isAtMostNChar(value, MAX_COST_CENTER_ID_LENGTH)) {
                    return Promise.reject(i18n.t("validation:max.string", { max: MAX_COST_CENTER_ID_LENGTH }))
                }

                return Promise.resolve()
            },
        },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
    name: [
        {
            validator: (_rule, value: string) => {
                if (isNotSet(value)) {
                    return Promise.reject(i18n.t("validation:required"))
                }

                const { formValues, existingValuesRaw } = FormService.getFormAndReduxValues("costCenters2", formInstance, formIsArray)
                if (!isUniqueInReduxAndForm({ formValues, existingValuesRaw, valueKey: "name", value, isEdit })) {
                    return Promise.reject(i18n.t("validation:unique", { value: i18n.t("validation:account_name") }))
                }

                if (value !== value.trim()) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space_start_or_end")))
                }

                if (textMultipleWhiteSpace.test(value)) {
                    return Promise.reject(new Error(i18n.t("validation:string_white_space_duplicate")))
                }

                return Promise.resolve()
            },
        },
        stringRules.allowedMultiLineCharsOnly,
    ] as Array<Rule>,
})
